/**
 * Compare two semver strings (major.minor.patch).
 * Returns true if `current` >= `minimum`.
 * If parsing fails, returns true (allow through).
 */
export function isVersionValid(current: string, minimum: string): boolean {
  try {
    const parse = (v: string) => v.split('.').map(Number);
    const [curMajor, curMinor = 0, curPatch = 0] = parse(current);
    const [minMajor, minMinor = 0, minPatch = 0] = parse(minimum);

    if (isNaN(curMajor) || isNaN(minMajor)) return true;

    if (curMajor !== minMajor) return curMajor > minMajor;
    if (curMinor !== minMinor) return curMinor > minMinor;
    return curPatch >= minPatch;
  } catch {
    return true;
  }
}
